<template>
  <div class="badge" v-bind:class="classObj">
    {{ status | snakeToTitleCase}}
  </div>
</template>

<script>
export default {
  props: [
    'status'
  ],
  data() {
    return {}
  },
  computed: {
    classObj: function() {
      switch (this.status) {
        case 'new':
        case 'pending_info':
        case 'pending_assignment':
        case 'pending_approval':
          return {'badge-info': true};
          break;
        case 'cancelled':
          return {'badge-danger': true};
          break;
        case 'approved':
        case 'sent':
          return {'badge-success': true};
          break;
        default:
          break;
      }
      return {'badge-default':true};
    },
    statusName: function() {
      return this.status;
    },
  },
  methods: {
  }
  // filters: {
  //   properCase(string) {
  //     return string.split('_').map(function(str) {
  //       return str.charAt(0).toUpperCase() + str.slice(1);
  //     }).join(' ');
  //   }
  // }
}
</script>
<style></style>
